"use client";

import { useEffect } from "react";
import NextErrorComponent from "next/error";

import { reportAppError } from "@stadium/services/error-reporting";

export default function MonitoringErrorComponent({ ErrorComponent = NextErrorComponent, error }) {
  useEffect(() => {
    reportAppError(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorComponent />
      </body>
    </html>
  );
}
